import { connect } from 'react-redux';
import { defaultMemoize } from 'reselect';

import { GenericMenuItemInfo } from '@tableau/widgets';

import { FeatureFlags } from '../../../ts/FeatureFlags';
import { DataRoleDefinition, FlowDefinition, MixedContentInOrder, MixedContentItemDefinition } from '../../../ts/models/ContentDefinitions';
import { ExploreContentApi_ContentType } from '../../../ts/ServerApi/types/IContent';
import { selectContentCounts } from '../../selectors/ContentCountsSelector';
import { AppState } from '../../state/AppState';
import { ISpaceInfoTypeItemCount, SpaceInfoTypeContentCounts } from '../../state/ContentCountsState';
import { MapStateToProps } from '../../utils/ConnectUtils';
import { ConnectedFilterByTypeMenuHelpers } from '../Components/ConnectedFilterByTypeMenuHelpers';
import { ExplorerListMenuPanel, ExplorerListMenuPanelOwnProps, ExplorerListMenuPanelStateProps } from '../Components/ExplorerListMenuPanel';

export const getContentDefinitionsForFavoritesSpaceMenu = (
  flowsEnabled: boolean
): MixedContentItemDefinition[] => {
  const items: MixedContentItemDefinition[] = [];

  for (const typeDef of MixedContentInOrder) {
    if ((typeDef.itemType === FlowDefinition.contentType && !flowsEnabled) ||
      (typeDef.itemType === DataRoleDefinition.contentType && !FeatureFlags.nlsemanticsServiceCustomDataRoleEnabled)){
      continue;
    }
    items.push(typeDef);
  }

  return items;
};

const getFavoritesSpaceMenuItems = (
  currentTypeFilters: ReadonlyArray<ExploreContentApi_ContentType>,
  contentCounts: ISpaceInfoTypeItemCount<'favorites'>,
  contentCountsUpToDate: boolean,
  showWorkbooksAsViews: boolean,
  flowsEnabled: boolean
): GenericMenuItemInfo[] => {
  return ConnectedFilterByTypeMenuHelpers.mapToMenuItems(
    getContentDefinitionsForFavoritesSpaceMenu(flowsEnabled),
    currentTypeFilters,
    contentCounts,
    contentCountsUpToDate
  );
};

const getFavoritesSpaceMenuItemsWrapper = defaultMemoize(getFavoritesSpaceMenuItems);

export const mapStateToFavoritesSpaceProps: MapStateToProps<ExplorerListMenuPanelStateProps> =
  (state: AppState) => {
    const contentCounts = selectContentCounts<'favorites'>(state, 'favorites');
    return ConnectedFilterByTypeMenuHelpers.mapStateToProps(state, contentCounts as SpaceInfoTypeContentCounts, getFavoritesSpaceMenuItemsWrapper);
  };

export const ConnectedFavoritesFilterByTypeMenu: React.ComponentClass<ExplorerListMenuPanelOwnProps> =
  connect(mapStateToFavoritesSpaceProps, ConnectedFilterByTypeMenuHelpers.mapDispatchToProps)(ExplorerListMenuPanel);
